import React from 'react';
import { Dropdown } from 'semantic-ui-react';

const DropDownList = ({options, name, placeholder, fluid, selection, onBlur, onChange, value}) => (
    <Dropdown
      name={name}
      placeholder={placeholder}
      fluid={fluid}
      selection={selection}
      options={options}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
    />
  );

export { DropDownList };
  